
import "./style.scss"
import { WidgetsProviderContext } from "./context"
import { TWidget, TWidgetsProvider } from "./types"
import { EmptyContent, getStorage } from "@cakemail-org/ui-components-v2"
import { Suspense, useEffect, useState } from "react"
import { Box, Grid, Stack, useTheme } from "@mui/material"
import { useTranslation } from "react-i18next"


export function WidgetsProvider({ name = "default", isEditMode, initLayout, ...props }: TWidgetsProvider) {
    const [layout, setLayout] = useState<TWidget[]>(initLayout || [])
    const [widgets, setWidgets] = useState<Record<string, React.FC<any> | false>>({})
    const { t } = useTranslation()
    const structureConfigs = name + "WidgetsStructure"

    useEffect(fetchWidgetsStructure, [])
    useEffect(loadWidget, [layout])

    function fetchWidgetsStructure() {
        const savedPageStructure = getStorage({ key: structureConfigs })
        try {
            //setTimeout(() => {
            //setLayout(JSON.parse(savedPageStructure) || [])
            //setLayout([{ name: "topPerformingAutomations" }])
            setLayout([{ name: "campaignKeyEngagementMetrics" }, { name: "audienceGrowth" }, { name: "campaignSpotlight" }, { name: "campaignProgressTracker" }, { name: "accountManagement" }])
            //}, 1000)

        } catch (e) {
            setTimeout(() => {
                setLayout([{ name: "audienceGrowth" }, { name: "campaignSpotlight" }])
            }, 1000)
        }
    }

    function loadWidget() {
        fetchWidgets()
    }

    async function fetchWidgets() {
        if (!layout)
            return
        const loadedWidgets: Record<string, React.FC<any> | false> = {}
        for (const widget of layout) {
            try {
                // Dynamically import the widget component
                const module = await import(`./${widget.name}`)
                loadedWidgets[widget.name] = module.default
            } catch (error) {
                loadedWidgets[widget.name] = false
                console.error(`Failed to load widget: ${widget.name}`, error)
            }
        }
        setWidgets(loadedWidgets)
    };

    return <Stack className="widgetsProvider" gap={6}>
        <WidgetsProviderContext.Provider value={{
            ...props,
            layout
        }}>

            {layout.length === 0 && <>
                <EmptyWidgetStructure />
                <EmptyWidgetStructure boxCount={1} />
                <EmptyWidgetStructure />
            </>}

            {layout?.filter(l => l.enabled !== false)?.map((widget) => {
                const WidgetComponent = widgets[widget.name]
                return (
                    <Suspense key={widget.name}>
                        {WidgetComponent !== undefined && <>
                            {WidgetComponent !== false ? <WidgetComponent {...widget} isEditMode={isEditMode} /> : <EmptyContent
                                title={t("widget-block-loading-error-title", { widget: widget.name })}
                            />}
                        </>}
                    </Suspense>
                )
            })}
        </WidgetsProviderContext.Provider >
    </Stack>
}


export function EmptyWidgetStructure({ boxCount = 3 }: { boxCount?: number }) {
    const theme = useTheme()
    return <Stack className="widget emptyWidgetStructure" gap={6}>
        <Box style={{
            background: theme?.palette?.cloud?.main,
            height: "30px",
            width: "20%",
            borderRadius: "24px"
        }}></Box>
        <Stack direction="row" gap={8}>
            {[...Array(boxCount)].map((_, index) => (
                <Grid item key={index} style={{
                    background: theme.palette.cloud.main,
                    height: "16rem",
                    minWidth: "16rem",
                    borderRadius: "24px"
                }}>
                </Grid>
            ))}
        </Stack>
    </Stack>
}